import { useRef } from "react";

/**
 * `fresh`, or while it is missing the last value seen in the same scope, so a new argument
 * doesn't blank the view. Nothing after a failure, and nothing carried into another scope.
 */
export function useHeldWhileLoading<T>(
  fresh: T | undefined,
  scope: string,
  isError: boolean,
): T | undefined {
  const last = useRef<{ scope: string; value: T } | null>(null);
  if (fresh !== undefined) {
    last.current = { scope, value: fresh };
    return fresh;
  }
  if (isError || last.current?.scope !== scope) return undefined;
  return last.current.value;
}
